import './App.css';
import { Route, Routes, useLocation } from 'react-router-dom';
import { lazy, Suspense, useState, useEffect } from 'react';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Loader from './components/Loader';
import SkipNav from './components/SkipNav';

// ─── Lazy-loaded pages (code splitting) ──────────────────────────────────────
// Each page is only downloaded when the user navigates to it.
const Home                    = lazy(() => import('./pages/home/Home'));
const About                   = lazy(() => import('./pages/about/About'));
const Antiquity               = lazy(() => import('./pages/antiquity-collection/antiquity'));

const History                 = lazy(() => import('./pages/about/History'));
const Scholar                 = lazy(() => import('./pages/scholar-cafe/scholar'));
const Contact                 = lazy(() => import('./pages/contact-us/Contact_Us'));
const Work                    = lazy(() => import('./pages/our-works/Works'));
const Work_Detail             = lazy(() => import('./pages/our-works/Education'));
const Healthcare              = lazy(() => import('./pages/our-works/Healthcare'));
const ArtsCulture             = lazy(() => import('./pages/our-works/ArtsCulture'));
const Water                   = lazy(() => import('./pages/our-works/Water'));
const Vision_Mission          = lazy(() => import('./pages/about/Vision_mission'));
const Our_Philosophy          = lazy(() => import('./pages/about/Our_Philosophy'));
const Trustees                = lazy(() => import('./pages/about/Trustees'));
const Lives_Transformed       = lazy(() => import('./pages/about/Lives_Transformed'));
const Livelihood              = lazy(() => import('./pages/our-works/Livelihood'));
const Newsletter              = lazy(() => import('./pages/events/Newsletter'));

const Partners                = lazy(() => import('./pages/partners/Partners'));
const News                    = lazy(() => import('./pages/events/News'));
const Education               = lazy(() => import('./pages/our-works/Education'));
const Our_Initiatives         = lazy(() => import('./pages/our-works/Our_Initiatives'));
const Our_Initiatives_SubCat  = lazy(() => import('./pages/our-works/Our_Initiatives_SubCategory'));
const Sub_Category            = lazy(() => import('./pages/our-works/Sub_Category'));
const Inner_Page              = lazy(() => import('./pages/our-works/Inner_Page'));
const Articles                = lazy(() => import('./pages/events/Articles'));
const Search                  = lazy(() => import('./pages/Search'));

// Page-level loading skeleton
const PageSkeleton = () => (
  <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <Loader />
  </div>
);

function Layout() {
  const [pageLoaded, setPageLoaded] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    setPageLoaded(false);
  }, [location.pathname]);

  return (
    <>
      <SkipNav />
      <Header />

      <main id="main-content" tabIndex="-1">
      <Suspense fallback={<PageSkeleton />}>
        <Routes>
          <Route path="/" element={<Home setPageLoaded={setPageLoaded} />} />
          <Route path="/our-work" element={<Work />} />
          <Route path="/about-us" element={<About />} />
       
          <Route path="/contact-us" element={<Contact />} />

          <Route path={`${process.env.PUBLIC_URL}/work-detail/*`} element={<Work_Detail />} />
          <Route path={`${process.env.PUBLIC_URL}/our-work/work-detail`} element={<Work_Detail />} />
          <Route path={`${process.env.PUBLIC_URL}/our-work/education`} element={<Education />} />
          <Route path={`${process.env.PUBLIC_URL}/our-work/livelihood`} element={<Livelihood />} />
          <Route path={`${process.env.PUBLIC_URL}/our-work/rural-development`} element={<Livelihood />} />
 
          <Route path={`${process.env.PUBLIC_URL}/our-work/water`} element={<Water />} />
          <Route path={`${process.env.PUBLIC_URL}/our-work/healthcare`} element={<Healthcare />} />
          <Route path="/our-work/arts-culture" element={<ArtsCulture />} />
          <Route path={`${process.env.PUBLIC_URL}/about-us/*`} element={<Vision_Mission />} />
          <Route path={`${process.env.PUBLIC_URL}/about-us/our-philosophy`} element={<Our_Philosophy />} />
          <Route path={`${process.env.PUBLIC_URL}/about-us/trustees`} element={<Trustees />} />
          <Route path={`${process.env.PUBLIC_URL}/about-us/history`} element={<History />} />
 
          <Route path={`${process.env.PUBLIC_URL}/about-us/lives-transformed`} element={<Lives_Transformed />} />
          <Route path={`${process.env.PUBLIC_URL}/events/newsletter`} element={<Newsletter />} />
 
          <Route path={`${process.env.PUBLIC_URL}/partners`} element={<Partners />} />
          <Route path={`${process.env.PUBLIC_URL}/events/news`} element={<News />} />
          <Route path={`${process.env.PUBLIC_URL}/our-work/:category/:sub-category`} element={<Sub_Category />} />
          <Route path={`${process.env.PUBLIC_URL}/our-work/:category/subCategoryName`} element={<Sub_Category />} />
          <Route path={`${process.env.PUBLIC_URL}/our-work/:category/:sub-category/our-initiatives`} element={<Our_Initiatives />} />
          <Route path={`${process.env.PUBLIC_URL}/our-work/:category/our-initiatives`} element={<Our_Initiatives />} />
          <Route path={`${process.env.PUBLIC_URL}/our-work/:category/our-initiatives/*`} element={<Inner_Page />} />
          <Route path={`${process.env.PUBLIC_URL}/our-work/:category/*`} element={<Inner_Page />} />
 
          <Route path="/our-work/:category/our-initiatives/:slug" element={<Inner_Page />} />
          <Route path={`${process.env.PUBLIC_URL}/events/:type/:slug`} element={<Inner_Page />} />
          <Route path={`${process.env.PUBLIC_URL}/events/:type/*`} element={<Inner_Page />} />
          <Route path={`${process.env.PUBLIC_URL}/search`} element={<Search />} />
          <Route path={`${process.env.PUBLIC_URL}/privacy-policy`} element={<Inner_Page />} />
          <Route path={`${process.env.PUBLIC_URL}/terms-use`} element={<Inner_Page />} />
        </Routes>
      </Suspense>

      </main>

      {(isHomePage ? pageLoaded : true) && <Footer />}
    </>
  );
}

export default Layout;
